import React from "react";
import AuthenticityTokenField from "../../../components/forms/AuthenticityTokenField";
import { Button } from "../../../components/ui/Buttons";
import { FieldLabel, TextInput } from "../../../components/ui/FormControls";
import { SurfaceCard } from "../../../components/ui/SurfaceCard";
import { AppLink } from "../../../components/ui/link";
import { AuthPageLayout } from "./AuthPageLayout";
import type { MainAppPageProps } from "../types";

type ResetPasswordPageProps = Pick<
  MainAppPageProps,
  "csrfToken" | "routes" | "passwordResetToken"
>;

export const ResetPasswordPage: React.FC<ResetPasswordPageProps> = ({
  csrfToken,
  routes,
  passwordResetToken,
}) => (
  <AuthPageLayout>
    <h1 className="mb-3 text-center font-display text-3xl font-semibold tracking-tight text-foreground">
      Choose a new password
    </h1>
    <p className="mb-8 text-center text-sm text-muted-foreground">
      Enter a new password for your account.
    </p>
    <SurfaceCard className="rounded-2xl border-border p-8 shadow-lg">
      <form action={routes.resetPassword} method="post">
        <AuthenticityTokenField csrfToken={csrfToken} />
        <input type="hidden" name="token" value={passwordResetToken ?? ""} />
        <div className="mb-4">
          <FieldLabel htmlFor="password">New password</FieldLabel>
          <TextInput
            id="password"
            name="password"
            type="password"
            placeholder="password"
            required
            minLength={8}
          />
        </div>
        <div className="mb-6">
          <FieldLabel htmlFor="password_confirmation">
            Confirm password
          </FieldLabel>
          <TextInput
            id="password_confirmation"
            name="password_confirmation"
            type="password"
            placeholder="password"
            required
            minLength={8}
          />
        </div>
        <Button
          type="submit"
          variant="premium"
          className="w-full py-3 font-medium"
        >
          Update password
        </Button>
      </form>
    </SurfaceCard>
    <p className="mt-6 text-center text-sm text-muted-foreground">
      <AppLink to={routes.login} variant="premium">
        Back to log in
      </AppLink>
    </p>
  </AuthPageLayout>
);
